import { useState, useEffect } from "react";
import moment from "moment";

export default function useCountdown(target) {
  const [timeLeft, setTimeLeft] = useState({
    Days: "00",
    Hours: "00",
    Minutes: "00",
    Seconds: "00",
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();
      const diff = moment.duration(target.diff(now));

      if (diff.asMilliseconds() <= 0) {
        clearInterval(interval);
        setTimeLeft({
          Days: "00",
          Hours: "00",
          Minutes: "00",
          Seconds: "00",
        });
        return;
      }

      setTimeLeft({
        Days: String(Math.floor(diff.asDays())).padStart(2, "0"),
        Hours: String(diff.hours()).padStart(2, "0"),
        Minutes: String(diff.minutes()).padStart(2, "0"),
        Seconds: String(diff.seconds()).padStart(2, "0"),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [target]);

  return timeLeft;
}
